import type { ReactNode } from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { Form } from '@/components/Form'
import { ErrorBlock } from '@/components/ErrorBlock'
import illustrationUrl from '@/assets/misc/img_team.svg'

export interface NewTeamModalProps {
  showing: boolean
  onClose: () => unknown
  corporateMode: boolean
  onSubmit: () => unknown
  isCreatePending: boolean
  createError: unknown
  onDismissError: () => void
  children: ReactNode
}

export function NewTeamModal({
  showing,
  onClose,
  corporateMode,
  onSubmit,
  isCreatePending,
  createError,
  onDismissError,
  children,
}: NewTeamModalProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isCreatePending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={illustrationUrl}
              alt="Illustration of a group"
            />
          )}
          <ModalSheetContentTitle>Create a new Team</ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Looking to collaborate on work? Create a team to get started!
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
        <ModalSheetContentBlock>
          <Form id="newTeam" onSubmit={() => onSubmit()}>
            {children}
          </Form>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      {!!createError && (
        <ErrorBlock
          tackOn="bottom"
          error={createError}
          onClose={onDismissError}
        />
      )}
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            isDisabled={isCreatePending}
            onPress={onClose}
          />
          <Button
            label="Add"
            type="submit"
            form="newTeam"
            variant="primary"
            isPending={isCreatePending}
            isDisabled={isCreatePending}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
